module.exports = __webpack_public_path__ + "static/media/churchschicken.3db52f91.png";